import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LandingCard from "../../components/common/landingCard/LandingCard";
import "./Landing.css";
import { useDispatch, useSelector } from "react-redux";
import { setActiveCardTitle } from "../../redux/actions/userTypeSlice";
import { getHeaderRoles } from "../../redux/actions/HeaderRoles/GetHeaderRolesSlice";
import { setTitle } from "../../redux/actions/dashboardTitle";
import { Loader } from "../../components/common/Loader";

const LandingPage = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [cardsData, setCardsData] = useState([]);
  const tabDetails = useSelector((state) => state?.dashboardDetails?.tabDetails);
  const getHeaderRolesSlice = useSelector((state) => state?.GetHeaderRolesSlice);

  useEffect(() => {
    const callPlantsData = async () => {
      localStorage.setItem("activeCard", 0);
      localStorage.setItem("approverActiveItem", "Pending Approval");
      localStorage.setItem("workflowActiveItem", "Pending Action");
      localStorage.setItem("lastVisitedPage", 0);
      localStorage.setItem("reportsActiveItem", "Lead Time Variations at Component Level");
      try {
        const responseHeaderRoles = await dispatch(getHeaderRoles({
          dynamicEndpoint: 'api/user/fetch-user-details',
        }));
        if (responseHeaderRoles?.meta?.requestStatus === 'fulfilled') {

          const rolesObj = responseHeaderRoles?.payload?.userRoles;

          const LTRole = localStorage.getItem("LTRole");
          const CDRole = localStorage.getItem("CDRole");
          const LTplantType = localStorage.getItem("LTplantType");
          const CDplantType = localStorage.getItem("CDplantType");
          const selectedLTPlant = localStorage.getItem("selectedLTPlant");
          const selectedCDPlant = localStorage.getItem("selectedCDPlant");
          const LTRegion = localStorage.getItem("LTRegion");
          const CDRegion = localStorage.getItem("CDRegion");

          if (rolesObj) {

            const matchedLT = rolesObj?.LT?.find(
              (item) =>
                item?.plant === selectedLTPlant &&
                item?.cokeRegion === LTRegion &&
                item?.plantType === LTplantType &&
                item?.roles?.some((r) => r === LTRole)
            );
            const matchedCD = rolesObj?.CD?.find(
              (item) =>
                item?.plant === selectedCDPlant &&
                item?.cokeRegion === CDRegion &&
                item?.plantType === CDplantType &&
                item?.roles?.some((r) => r === CDRole)
            );

            const roleLTPath = matchedLT ? LTRole : rolesObj?.LT?.[0]?.roles?.[0];
            const plantTypeLTPath = matchedLT ? LTplantType : rolesObj?.LT?.[0]?.plantType;

            const roleCDPath = matchedCD ? CDRole : rolesObj?.CD?.[0]?.roles?.[0];
            // const plantTypeCDPath = matchedCD? CDplantType: rolesObj?.CD?.[0]?.plantType;

            setCardsData([
              {
                id: 1,
                appCode: "LT",
                title: "Lead Time Analytics",
                disabled: rolesObj?.LT?.length === 0,
                url: (roleLTPath === "Admin" && plantTypeLTPath === "CPS")
                  ? "/run-analytics-scheduler"
                  : (roleLTPath === "Approver" && plantTypeLTPath === "CPS")
                    ? "/approval-management"
                    : (roleLTPath === "Planner" && plantTypeLTPath === "CPS")
                      ? "/lt-dashboard"
                      : (roleLTPath === "Planner" && plantTypeLTPath === "DPS")
                        ? "/DPS-Planner-analytics"
                        : (roleLTPath === "Viewer" && plantTypeLTPath === "CPS")
                          ? "/viewer-analytics-results"
                          : (roleLTPath === "GMP" && plantTypeLTPath === "CPS")
                            ? "/gmp-dashboard"
                            : "",
              },
              {
                id: 2,
                appCode: "CD",
                title: "Contract Data Update",
                url: roleCDPath === "Admin"
                  ? "/cd-dashboard"
                  : roleCDPath === "Approver"
                    ? "/cd-dashboard"
                    : roleCDPath === "Planner"
                      ? "/cd-dashboard"
                      : roleCDPath === "Viewer"
                        ? "/cd-dashboard"
                        : roleCDPath === "GMP"
                          ? "/cd-dashboard"
                          : roleCDPath === "Analyst"
                            ? "/cd-dashboard"
                            : roleCDPath === "MOP"
                              ? "/cd-dashboard"
                            : roleCDPath === "Price Memo Owner (Packaging)"
                              ? "/pricememo-management"
                            : roleCDPath === "Price Memo Viewer (Packaging)"
                              ? "/packaging-viewer-pricememo"
                            : roleCDPath === "Price Memo Owner (CEPG)"
                              ? "/pricememo-management"
                            : roleCDPath === "Price Memo Viewer (CEPG)"
                              ? "/packaging-viewer-pricememo"
                              : "",
                disabled: rolesObj?.CD?.length === 0,
              },
              {
                id: 3,
                appCode: "AR",
                title: "Supplier Collaboration",
                redirectUrl: true,
                url: process.env.REACT_APP_SC_URL,
              },
              {
                id: 4,
                appCode: "PO",
                title: "PO Management",
                redirectUrl: true,
                url: process.env.REACT_APP_PO_URL
              },
              {
                id: 5,
                appCode: "GRPT",
                title: "GRPT Analytics",
                redirectUrl: true,
                url: process.env.REACT_APP_GRPT_URL
              },
            ])
          }
        }
      } catch (error) {
        console.error('API error:', error);
      }
    }
    if (tabDetails.title === "Landing") {
      callPlantsData();
    }
  }, [tabDetails])

  const handleCardClick = (title, url) => {
    dispatch(setActiveCardTitle(title));
    // Set the tabDetails in Redux so MainContent can properly render
    dispatch(setTitle({ title: title }));
    
    // Set appropriate localStorage values based on card title
    if (title === "Contract Data Update") {
      localStorage.setItem('cardTitle', 'Contract Data Update');
      localStorage.setItem('pageName', 'Price Memo');
    } else if (title === "Lead Time Analytics") {
      localStorage.setItem('cardTitle', 'Lead Time Analytics');
      localStorage.setItem('pageName', 'Price Memo');
    }
    
    // Navigate to the URL
    if (url) {
      navigate(url);
    }
  };

  return (
    <div className="Landing-main">
      {getHeaderRolesSlice?.loading ? <Loader />
        : <div className="landing_cards_cls">
          {cardsData?.map((data) => {
            return (
              <LandingCard
                key={data.id}
                title={data.title}
                appCode={data.appCode}
                url={data.url}
                disabled={data.disabled}
                onClick={() => handleCardClick(data?.title, data?.url)}
              />
            );
          })}
        </div>
      }
    </div>
  );
};

export default LandingPage;
